<template>
  <!-- 安保档案填报 -->
  <the-no-authority v-if="!authority"></the-no-authority>
  <div class="page_box" v-else>
    <!-- 暂无权限 -->
    <div class="page_option_box">
      <div class="option_box">
        <input
          type="file"
          id="xlsFile"
          accept=".xls,.xlsx"
          @change="importData($event)"
        />
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="openAddBox"
          >新增</el-button
        >
        <el-button
          type="primary"
          plain
          icon="el-icon-download"
          size="mini"
          @click="
            $Common.fileDownloads('files/20200616/安保人员信息导入模板.xls')
          "
          >下载模版</el-button
        >
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-bottom-right"
          @click="selectFileImport()"
          >导入</el-button
        >
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-top-right"
          @click="exportData()"
          :disabled="responseData.list.length == 0"
          >导出</el-button
        >
        <el-button
          type="danger"
          plain
          size="mini"
          icon="el-icon-circle-close"
          @click="delData()"
          :disabled="delDataList.length < 1 ? true : false"
          >删除</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="selectDelData"
        >
          <el-table-column type="selection" width="40" align="center">
          </el-table-column>
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                responseData.pageSize * (responseData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" align="center">
          </el-table-column>
          <el-table-column prop="securityPhone" label="联系方式" align="center">
          </el-table-column>
          <el-table-column
            prop="securityCompany"
            label="所属机构"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="chargeName" label="负责人姓名" align="center">
          </el-table-column>
          <el-table-column prop="chargePhone" label="负责人电话" align="center">
          </el-table-column>
          <el-table-column label="操作" width="180px" align="center">
            <template slot-scope="rowData">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="openEditBox(rowData.row.id)"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="delData(rowData.row.id)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="type == 'add' ? '新增安保档案信息' : '编辑安保档案信息'"
      :visible.sync="showBox"
      direction="ltr"
      :append-to-body="true"
      @close="drawerClose"
      width="800px"
      :wrapperClosable="false"
      :close-on-press-escape="false"
    > 
   
      <security-add-or-edit
        :defaultData="infoData"
        :showBox="showBox"
        @saveSubmit="saveSubmit"
        @cencelSubmit="cencelSubmit"
      ></security-add-or-edit>
        
    </el-dialog>
  </div>
</template>

<script>
import theNoAuthority from "@/components/theNoAuthority";
import SecurityAddOrEdit from "./components/SecurityAddOrEdit";
export default {
  name: "",
  components: {
    theNoAuthority,
    SecurityAddOrEdit
  },
  props: {},
  data() {
    return {
      // 有无权限
      authority: true,
      requestData: {
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNum: 1
      },
      responseData: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
        pages: 0,
        list: []
      },
      delDataList: [],
      type: "add",
      showBox: false,
      infoData: {
        id: "",
        name: "",
        sex: 0,
        securityPhone: "",
        idCard: "",
        birthday: "",
        age: "",
        employType: 0,
        securityCompany: "",
        img: "",
        chargeName: "",
        chargePhone: "",
        chargeJob: "",
        schoolId: this.$store.state.schoolId
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    selectedAddDataDate() {
      this.addData.age = this.$Common.calculationAges(this.addData.birthday);
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getDataList();
    },
    selectFileImport() {
      document.getElementById("xlsFile").click();
    },
    // 导入数据
    async importData() {
      var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "数据导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var requestData = {
        file: fileUpload
      };
      var newData = {
        schoolId: this.$store.state.schoolId,
        file: fileUpload
      };
      document.getElementById("xlsFile").value = null;
      let res = await this.$Http.importSecurityArchives(newData, true);

      // console.log(responseData)

      loading.close();
      if (res&&res.code == 200) {
        this.$message({
          type: "success",
          message: "导入成功"
        });
        this.getDataList();
      } else if (res&&res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res&&res.messsage
        });
      }
    },
    // 导出数据
    async exportData() {
      var req = {
        schoolId: this.$store.state.schoolId
      };
      this.$Common.exportData(req, "exportSecurityArchives", "安保档案");
    },
    async getDataList() {
      var newParamData = this.requestData;
      let res = await this.$Http.getSecurityArchives(newParamData);
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize;
        this.responseData.pageNum = res.data.pageNum;
        this.responseData.total = res.data.total;
        this.responseData.pages = res.data.pages;
        this.responseData.list = res.data.list;
      } else if (res.code == 101) {
        this.responseData.total = 0;
        this.responseData.list = [];
      } else if (res.code == 102) {
        this.authority = false;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 清除数据
    clearData() {
      this.infoData = {
        id: "",
        name: "",
        sex: 0,
        securityPhone: "",
        idCard: "",
        birthday: "",
        age: "",
        employType: 0,
        securityCompany: "",
        img: "",
        chargeName: "",
        chargePhone: "",
        chargeJob: "",
        schoolId: this.$store.state.schoolId
      };
    },
    // 打开新增/编辑
    openAddBox() {
      this.type = "add";
      this.showBox = true;
    },
    // 关闭新增/编辑
    drawerClose() {
      this.showBox = false;
      this.clearData();
    },
    // 提交
    saveSubmit(info) {
      if (this.type == "add") {
        delete info.id;
      }
      this.operationSecurityArchives(info);
    },
    // 取消
    cencelSubmit() {
      this.showBox = false;
      this.clearData();
    },
    // 获取编辑信息
    async openEditBox(id) {
      var newParamData = {
        id: id
      };
      let res = await this.$Http.detailsSecurityArchives(newParamData);
      if (res.code == 200) {
        this.infoData.id = res.data.id;
        this.infoData.name = res.data.name;
        this.infoData.securityPhone = res.data.securityPhone;
        this.infoData.idCard = res.data.idCard;
        this.infoData.birthday = res.data.birthday == 0 ? '' : res.data.birthday * 1000;
        this.infoData.age = res.data.age == 0 ? '' : res.data.age;
        this.infoData.sex = res.data.sex;
        this.infoData.employType = res.data.employType;
        this.infoData.securityCompany = res.data.securityCompany;
        this.infoData.img = res.data.img;
        this.infoData.chargeName = res.data.chargeName;
        this.infoData.chargePhone = res.data.chargePhone;
        this.infoData.chargeJob = res.data.chargeJob;
        this.showBox = true;
        this.type = "edit";
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 选择要删除的风险辨识
    selectDelData(objList) {
      this.delDataList = [];
      objList.forEach((element) => {
        this.delDataList.push(element.id);
      });
    },
    // 删除数据
    delData(dataId = 0) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          if (dataId >= 1) {
            var requestData = {
              ids: dataId
            };
          } else {
            if (this.delDataList.length < 1) {
              this.$message({
                type: "error",
                message: "请先选择您要删除的数据"
              });
              return false;
            }

            var requestData = {
              ids: this.delDataList.join(",")
            };
          }
          var newRequestData = requestData;
          let res = await this.$Http.delSecurityArchives(newRequestData, true);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    // 提交新增 / 编辑数据
    async operationSecurityArchives(info) {
      var newParamData = Object.assign({}, info);
      newParamData.birthday = newParamData.birthday / 1000;
      let res = await this.$Http.operationSecurityArchives(newParamData, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: this.type == "add" ? "新增成功" : "编辑成功"
        });
        this.getDataList();
        this.cencelSubmit();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: this.type == "add" ? "新增失败" : "编辑失败"
        });
      }
    }
  },
  created() {},
  mounted() {
    this.getDataList();
  }
};
</script>
<style scoped></style>
